export enum ROUTE_NETWORK {
  ACTIVITY = 'network',
  INVITATIONS = 'network-invitations',
  USER_ACTIVITY = 'network-user-thread_id-index-activity',
  USER_NETWORK = 'network-user-thread_id-index-network',
  USER_PROFILE = 'network-user-thread_id-index-profile',
  USER_HOME = 'network-user-thread_id-index',
}
